import { createHash } from 'crypto'

export enum EVENTS_TIKTOK_PIXEL {
  SUBMIT_FORM = 'SubmitForm',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const tiktokEvent = (title: EVENTS_TIKTOK_PIXEL, data?: any) => {
  ;(window as any).ttq.track(title, data)
}

const hashEmail = (email: string): string => {
  if (!email) return ''
  return createHash('sha256').update(email.toLowerCase().trim()).digest('hex')
}

export const tiktokIdentify = (email: string) => {
  ;(window as any).ttq.identify({
    email: hashEmail(email),
  })
}
